<template>
  <div>
    <!-- 关联商品 -->
    <el-form-item size="small" label="选择商品">
      <el-button icon="el-icon-plus" @click="changeProduct(form.product)">选择商品</el-button>
      <div class="pb50" style="margin-top: 10px;">
        <el-table size="small" :data="form.product" border>
          <el-table-column label="图片" width="60">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img width="30px" height="30px" v-img-url="scope.row.product_image" alt="product_image"/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="num" label="设置数量">
            <template slot-scope="scope">
                <el-input v-model="scope.row.set_num"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

  </div>
</template>

<script>
import Product from '@/components/product/Product';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    Product,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
    };
  },
  props: {
    form: Object,
    type: String
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_price: item.product_price,
            product_image: item.product_image,
            set_num:1
          };
          arr.push(obj);
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let curItem = this.form.product[e];
      for (let i = 0; i < this.form.product.length; i++) {
        let item = this.form.product[i];
        if (curItem.product_id == item.product_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let product_id = item.product_id;
            // this.form.product_del_ids.push(product_id);
          }
          this.form.product.splice(i, 1);
          i--;
        }
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/grade/Relationproduct.vue